import AT from '../actionTypes'

export const setUserInfo = user => {
  return { type: AT.SET_USER_INFO, payload: user }
}

export const setLoanFileId = loanFileId => {
  return { type: AT.SET_LOAN_FILE_ID, payload: loanFileId }
}
